/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
const Enumerable = require("linq");
import * as moment from 'moment';

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("InvoicesSetDeliverAfterController", [
            "$scope", "$http", "invoice", "$oidc",
            function ($scope, $http, invoice, oidc) {
                $scope.number = invoice.Number;
                $scope.units = Enumerable
                    .from(invoice.InvoiceUnits)
                    .where(function (unit) { return unit.IsCentralFleet })
                    .select(function (unit) { return unit })
                    .toArray();
                $scope.date = moment().toDate();

                $scope.minDate = moment().toDate();
                $scope.maxDate = moment().add(1, "month").toDate();

                $scope.setDeliverAfter = function () {
                    return $http
                        .put("/api/retail/deliver-after", {}, {
                            params: {
                                deliveryIds: Enumerable
                                    .from($scope.units)
                                    .select(function (unit) { return unit.SalesOrderLineId })
                                    .toArray(),
                                date: $scope.date
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function () {
                            $scope.$close();
                        }, function () {
                            $scope.$dismiss();
                        });
                };
            }
        ]);
})();